import { FeatureFlagConfig } from "../components/shared/feature-flag-react-lite";
import rawLocalFeatureFlags from "./feature-flag-default-values.json";
import { AxiosRequestConfig } from "axios";

// Convert the raw default values to the correct type
const defaultFeatureFlags = rawLocalFeatureFlags.featureFlags.map(flag => ({
  ...flag,
  retirementDate: new Date(flag.retirementDate),
}));

const axiosHeaders = async (config: AxiosRequestConfig) => {
  // if config is not null
  if (config && config.headers) {
    config.headers["Cache-Control"] = `no-cache`;
    config.headers["Pragma"] = `no-cache`;
    config.headers["Expires"] = `0`;
  }
  return config;
};

export const featureFlagConfig: FeatureFlagConfig = {
  cache: 30 * 1000,
  url: import.meta.env.VITE_FEATURE_FLAG_URL ?? "",
  fallbackFlagValues: { featureFlags: defaultFeatureFlags },
  axiosRequestConfig: axiosHeaders,
};

export const storybookFeatureFlagConfig: FeatureFlagConfig = {
  cache: 30 * 1000,
  url: import.meta.env.VITE_FEATURE_FLAG_URL ?? "",
  fallbackFlagValues: { featureFlags: defaultFeatureFlags },
  axiosRequestConfig: axiosHeaders,
};
